import { http } from "../http";
import type { ImportJob } from "./Venues";

export type RecognitionMetrics = {
  auddCalls: number;
  localHits: number;
  localMisses: number;
  localRejected: number;
  windowSuppressed: number;
  spotifyLabelled: number;
  fingerprintsStored: number;
  fingerprintsDuplicate: number;
  fingerprintErrors: number;
};

export type AdminOverview = {
  generatedAt: string;
  users: { total: number; newLast7Days: number };
  venues: {
    total: number;
    active: number;
    premium: number;
    needsReview: number;
    missingHours: number;
    premiumWithoutSensor: number;
  };
  sensors: {
    total: number;
    online: number;
    offline: number;
    unclaimed: number;
    failedOta: number;
  };
  recognition: {
    today: RecognitionMetrics & { handled: number };
    last7Days: RecognitionMetrics;
  };
  productUsage: {
    venueViews: number;
    directionsClicks: number;
    checkIns: number;
    onMyWayCreated: number;
    onMyWayArrived: number;
    inviteConversions: number;
  };
  imports: {
    failed: number;
    active: number;
    recent: ImportJob[];
  };
};

export function getAdminOverview() {
  return http.get<AdminOverview>("/admin/overview");
}
